(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Product-description-truncated-readmore"] && !Shopify.designMode) return;
  try {
    
  descriptionBlock = document.getElementById("descriptionreadmore");
  readMoreLink = document.getElementById("readmore-link");
  readMoreLink.addEventListener('click', expandArticle);
  
  function expandArticle(e) {
    // record if our text is expanded
    var isExpanded =  readMoreLink.classList.contains("expand");
    
    // if target wasn't expand, then expand it
    if (!isExpanded){
      descriptionBlock.classList.add("expand");
      readMoreLink.classList.add("expand");
    } else {
      descriptionBlock.classList.remove("expand");
      readMoreLink.classList.remove("expand");      
    }
  };  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-rich-description"] && !Shopify.designMode) return;
  try {
    
  descriptionBlock = document.getElementById("descriptionreadmore");
  readMoreLink = document.getElementById("readmore-link");
  readMoreLink.addEventListener('click', expandArticle);
  
  function expandArticle(e) {
    // record if our text is expanded
    var isExpanded =  readMoreLink.classList.contains("expand");
    
    // if target wasn't expand, then expand it
    if (!isExpanded){
      descriptionBlock.classList.add("expand");
      readMoreLink.classList.add("expand");
    } else {
      descriptionBlock.classList.remove("expand");
      readMoreLink.classList.remove("expand");      
    }
  };  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchMobile', this.close.bind(this));
    document.addEventListener('unmatchMobile', this.open.bind(this));

    if (FoxThemeSettings.isMobile) {
      this.close()
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.site-header__wrapper');
    }

    onToggle() {
      if (!this.header) return;
      this.header.preventReveal = this.mainDetailsToggle.open;
    }
  }
  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inner-announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-truncated"] && !Shopify.designMode) return;
  try {
    
  const ps = document.querySelectorAll('p');
  const observer = new ResizeObserver(entries => {
    for (let entry of entries) {
      entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('truncated');
    }
  });
  
  ps.forEach(p => {
    observer.observe(p);
  });

  } catch(e) { console.error(e); }
})();
})();
